import { Checkbox } from "antd";
import React, { useMemo } from "react";
import Icon, { ICON_NAME } from "../../../../../../components/Icon";
import Menu from "../../../../../../components/Menu";
import { IDeliveryTypeUnit, IStorage } from "../../../../../../util/varibles/interface";
import { useEditOp } from "../../EditOperationContext";

interface IProps {
    data: IDeliveryTypeUnit["tanks"]

    onChange(value: IDeliveryTypeUnit["tanks"]): void
}

const Tanks: React.FC<IProps> = ({ data = [], onChange }) => {
    const ids = new Set(data.map(item => item.id));
    const [vesselTanks = []] = useEditOp(state => state.vesselTanks);
    const names = useMemo(() => vesselTanks.reduce((rs: { [id: string]: string }, item) => {
        rs[item.id || ''] = item.name;
        return rs;
    }, {}), [vesselTanks])

    const handleChange = (checked: boolean, value: IStorage) => {
        if (checked) {
            onChange([...data.map(({ id, name }) => ({ id, name })), { id: value.id || '', name: value.name }]);
        } else {
            onChange(data.filter(item => item.id !== value.id).map(({ id, name }) => ({ id, name })));
        }
    }

    const name = data.map(item => names[item.id]).join(', ')

    return <div className='w-full'>
        <Menu
            classNames={{ root: 'max-w-[200px] w-full' }}
            placement='bottomLeft'
            items={[{
                key: '1',
                className: 'no-hover',
                disabled: true,
                label: <div className='flex flex-col gap-3 py-1'>
                    {vesselTanks.map(item => {
                        const checked = ids.has(item.id || '')
                        return <Checkbox
                            key={item.id}
                            checked={checked}
                            onChange={({ target }) => handleChange(target.checked, item)}
                        >
                            {item.name}
                        </Checkbox>;
                    })}
                </div>
            }]}
        >
            <div className="flex items-center w-fit cursor-pointer h-full">
                <span className='truncate' title={name}>
                    {name}
                </span>
                {data.length === 0 && <span className='italic text-comment'>Select tank</span>}
                <Icon className='ml-2' icon={ICON_NAME.ARROW_DOWN} size={10} />
            </div>
        </Menu>
    </div>;
};

export default Tanks;
